"use client";

import { useState, useRef } from "react";

export default function CareerPage() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dateOfBirth: "",
    about: "",
    exp: "",
    resume: null,
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
  const { name, value, files } = e.target;

  const newValue = files ? files[0] : value;

  setForm((prev) => ({
    ...prev,
    [name]: newValue,
  }));

  // Remove error when resume is uploaded
  if (name === "resume" && files?.[0]) {
    setErrors((prev) => ({
      ...prev,
      resume: "",
    }));
  }
};


  const validateForm = () => {
    const newErrors = {};
    if (!form.firstName.trim()) newErrors.firstName = "First name is required";
    if (!form.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!form.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      newErrors.email = "Enter a valid email";
    if (!form.phone.trim()) newErrors.phone = "Phone is required";
    else if (!/^\d{10}$/.test(form.phone))
      newErrors.phone = "Enter a valid 10-digit number";
    if (!form.dateOfBirth.trim())
      newErrors.dateOfBirth = "Date of Birth is required";
    if (!form.resume) newErrors.resume = "Please upload resume";
    if (form.about.length > 500) {
    newErrors.about = "About Yourself cannot exceed 500 characters";
  }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const formData = new FormData();
    formData.append("firstName", form.firstName);
    formData.append("lastName", form.lastName);
    formData.append("mobileNo", form.phone);
    formData.append("email", form.email);
    formData.append("dateOfBirth", form.dateOfBirth);
    formData.append("profile", form.about);
    formData.append("exp", form.exp);

    if (form.resume) {
      formData.append("cvUpload", form.resume);
    }

    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}api/common/Careers`,
        {
          method: "POST",
          body: formData, // ✅ Important: No headers
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || `HTTP ${res.status}`);
      }

      // Reset Form
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        dateOfBirth: "",
        phone: "",
        about: "",
        resume: null,
        exp: "",
      });

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      setSuccessMessage("Application submitted successfully!");
      setTimeout(() => setSuccessMessage(""), 5000);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="mt-5 my-4 px-3 md:!px-12" style={{ minHeight: "100vh" }}>
        <h1 className="text-center !text-[23px] fw-semibold mb-4">
          Careers at Orange Tiger Hospitality Pvt Ltd.
        </h1>
        <div
          className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-3"
          style={{ background: "#f26624" }}
        ></div>
        <div className="text-center !text-[14px] text-muted w-full md:w-3/4 mx-auto lh-base">
          <p className="mb-5">
            At Orange Tiger Hotels, we believe exceptional hospitality starts
            with exceptional people. Whether welcoming guests, crafting unique
            experiences, or driving seamless operations behind the scenes, every
            role plays a vital part in our success. We are building a dynamic
            team of passionate, creative professionals dedicated to delivering
            warm and memorable guest stays. If you seek a workplace that values
            your ideas, fosters growth, and offers diverse opportunities each
            day, join us.
          </p>
        </div>
        <div
          className="mx-auto w-full lg:w-1/2"
          style={{
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            padding: "20px",
          }}
        >
          <h4
            className="mb-4 text-uppercase text-center !text-[18px] fw-semibold"
            style={{ letterSpacing: "1px" }}
          >
            Application Form
          </h4>
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col">
                <label htmlFor="firstName" className="form-label">
                  First Name <span className="text-danger">*</span>
                </label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  value={form.firstName}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.firstName && (
                  <small className="text-danger">{errors.firstName}</small>
                )}
              </div>
              <div className="col">
                <label htmlFor="lastName" className="form-label">
                  Last Name <span className="text-danger">*</span>
                </label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  value={form.lastName}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.lastName && (
                  <small className="text-danger">{errors.lastName}</small>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label htmlFor="email" className="form-label">
                  Email Address <span className="text-danger">*</span>
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}
              </div>
              <div className="col">
                <label htmlFor="phone" className="form-label">
                  Phone <span className="text-danger">*</span>
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={form.phone}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label htmlFor="dateOfBirth" className="form-label">
                  Date of Birth <span className="text-danger">*</span>
                </label>
                <input
  id="dateOfBirth"
  name="dateOfBirth"
  type="date"
  value={form.dateOfBirth}
  onChange={handleChange}
  className="form-control"
  max={new Date(Date.now() - 86400000).toISOString().split("T")[0]}
  required
/>
                {errors.dateOfBirth && (
                  <small className="text-danger">{errors.dateOfBirth}</small>
                )}
              </div>
              <div className="col">
                <label htmlFor="exp" className="form-label">
                  Experience
                </label>
                <input
                  id="exp"
                  name="exp"
                  type="text"
                  value={form.exp}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

            <div className="mb-3">
              <div className="col">
                <div className="bg-white text-black">
                  <label htmlFor="resume" className="form-label mb-2">
                    Upload Resume <span className="text-danger">*</span>
                  </label>
                  <input
                    id="resume"
                    name="resume"
                    type="file"
                    accept=".pdf,.doc,.docx"
                    className="form-control"
                    onChange={handleChange}
                    ref={fileInputRef}
                  />
                </div>
                {errors.resume && (
                  <small className="text-danger">{errors.resume}</small>
                )}
              </div>
            </div>

            <div className="mb-3">
  <label htmlFor="about" className="form-label">
    Write About Yourself
  </label>

  <textarea
    id="about"
    name="about"
    rows={4}
    value={form.about}
    onChange={handleChange}
    className={`form-control ${
      errors.about ? "is-invalid" : ""
    }`}
    maxLength={500}
    placeholder="Write About Yourself"
  />

  <div className="d-flex justify-content-between mt-1">
    {errors.about ? (
      <small className="text-danger">
        {errors.about}
      </small>
    ) : (
      <span></span>
    )}

    <small
      className={
        form.about.length >= 500
          ? "text-danger"
          : "text-muted"
      }
    >
      {form.about.length}/500
    </small>
  </div>
</div>


            <div className="text-center">
              <button
                type="submit"
                className="btn text-white !text-[12px] px-3"
                style={{ letterSpacing: "2px", background: "#f04e02" }}
              >
                SUBMIT
              </button>
            </div>
            {successMessage && (
              <p className="text-success mt-2">{successMessage}</p>
            )}
          </form>
        </div>
      </div>
    </>
  );
}
